import React, { useState } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import useAutocomplete from '@material-ui/lab/useAutocomplete';
import { setTrainNo } from '../../redux/cart/cart.action';
import { selectTrainNo } from '../../redux/cart/cart.selector'

import './journey-details.style.css';

function UseAutocomplete({ trainNo, setTrainNo }) {

    const value = trainNo;
    const [trainEntered, setTrainEntered] = useState(trainNo);
    const [trains, setTrains] = useState([]);;
    const {
        getRootProps,
        getInputLabelProps,
        getInputProps,
        getListboxProps,
        getOptionProps,
        groupedOptions,
    } = useAutocomplete({
        id: 'train_name',
        options: trains,
        value: value,
        getOptionLabel: (option) => option,
        onChange: (event, newValue) => {
            setTrainEntered(newValue);
            if (!newValue) {
                setTrainNo('');
            } else {
                setTrainNo(newValue);
            }
        },
        onInputChange: (event, newValue) => {

            setTrainEntered(newValue);
            document.getElementById('train_name_error').style.display = 'none';

            //Fetch from API and change the options array    
            if (newValue.length >= 4) {

                fetch('https://foodapi.railyatri.in/live/mapiV2/search/type/json?q=' + newValue + '&limit=10&train=12')
                    .then(res => res.json())
                    .then((data) => { setTrains(data); })
            }

        }

    });

    return (
        <div className={`train-name ${(trainEntered === '' || trainEntered === null) ? 'empty' : ''}`}>
            <div {...getRootProps()}>
                <label className={"station-label"} {...getInputLabelProps()}>
                    Train number/name*
                </label>
                <input
                    type="text"
                    className="inputTrain"
                    id="train_name"
                    value={value}
                    onInput={(event) => {
                        setTrainEntered(event.target.value);
                        document.getElementById('train_name_error').style.display = "none";
                    }
                    }
                    
                    {...getInputProps()} />
            </div>
            {groupedOptions.length > 0 ? (
                <ul style={{ width: "100%", boxSizing: "border-box", boxShadow: "0 2px 10px rgba(0,0,0,0.2)", borderColor: "#eee", borderRadius: "5px" }} className="listbox" {...getListboxProps()}>
                    {groupedOptions.map((option, index) => (
                        <li style={{ paddingBottom: "10px" }}{...getOptionProps({ option, index })}>{option}</li>
                    ))}
                </ul>
            ) : null}
            <span id="train_name_error" className="errorbox" style={{ display: "none" }}>Enter train name/number</span>
        </div>
    );
}

const mapStateToProps = createStructuredSelector({
    trainNo: selectTrainNo
})

const mapDispatchToProps = dispatch => ({
    setTrainNo: trainNo => dispatch(setTrainNo(trainNo))
})

export default connect(mapStateToProps, mapDispatchToProps)(UseAutocomplete);